

// Funciones utiles

// Obtiene el primer dia del mes actual
export const getFirstDayCurrentMonth = () => {
  const hoy = new Date();
  const year = hoy.getFullYear();
  const month = String(hoy.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}-01`;
};

// Obtiene el ultimo dia del mes actual
export const getLastDayCurrentMonth = () => {
  const hoy = new Date();
  const year = hoy.getFullYear();
  const month = String(hoy.getMonth() + 1).padStart(2, '0');
  const lastDay = new Date(year, hoy.getMonth() + 1, 0).getDate();
  const day = String(lastDay).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
